import React from 'react';
import { Link } from 'react-router-dom';
import { ClockIcon, ShieldCheckIcon, DollarSignIcon } from 'lucide-react';
export function ValueProp() {
  return <section className="px-6 pb-24 bg-white" data-id="element-206">
      <div className="max-w-7xl mx-auto" data-id="element-207">
        <div className="bg-espresso text-alabaster p-8 md:p-20 border-3 border-charcoal shadow-[12px_12px_0px_0px_rgba(26,26,26,1)] md:shadow-[16px_16px_0px_0px_rgba(26,26,26,1)]" data-id="element-208">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-209">
            <div data-id="element-210">
              <h2 className="text-3xl md:text-5xl font-bold mb-8 leading-tight" data-id="element-211">
                Luxury Craftsmanship, <br data-id="element-212" />
                <span className="italic font-serif font-normal" data-id="element-213">
                  Without the Luxury Price Tag.
                </span>
              </h2>
              <p className="text-alabaster/80 text-lg mb-12 leading-relaxed" data-id="element-214">
                NK Refacers delivers a brand-new kitchen aesthetic using your
                existing structural footprint. We eliminate the demolition
                phase, saving you thousands while maintaining uncompromising
                quality.
              </p>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-8" data-id="element-215">
                <div className="flex gap-4" data-id="element-216">
                  <div className="bg-alabaster/10 p-3 h-fit" data-id="element-217">
                    <ClockIcon className="w-6 h-6" data-id="element-218" />
                  </div>
                  <div data-id="element-219">
                    <h4 className="font-bold mb-1" data-id="element-220">48-Hour Turnaround</h4>
                    <p className="text-sm text-alabaster/60" data-id="element-221">
                      Back in your kitchen by dinner.
                    </p>
                  </div>
                </div>
                <div className="flex gap-4" data-id="element-222">
                  <div className="bg-alabaster/10 p-3 h-fit" data-id="element-223">
                    <ShieldCheckIcon className="w-6 h-6" data-id="element-224" />
                  </div>
                  <div data-id="element-225">
                    <h4 className="font-bold mb-1" data-id="element-226">Zero Mess Policy</h4>
                    <p className="text-sm text-alabaster/60" data-id="element-227">
                      No demolition or structural dust.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-alabaster text-charcoal p-10 border-3 border-charcoal space-y-8" data-id="element-228">
              <div className="flex items-center gap-4 border-b-2 border-charcoal/10 pb-6" data-id="element-229">
                <DollarSignIcon className="w-8 h-8 text-espresso" data-id="element-230" />
                <div data-id="element-231">
                  <h3 className="text-2xl font-bold" data-id="element-232">Transparent Pricing</h3>
                  <p className="text-sm text-charcoal/60" data-id="element-233">
                    No upselling. No hidden fees.
                  </p>
                </div>
              </div>
              <ul className="space-y-4" data-id="element-234">
                {['Custom-Made Door Fronts', 'High-Pressure Matching Veneers', 'Soft-Close Hardware Included', 'Professional Installation'].map((item, i) => <li key={i} className="flex items-center gap-3 font-medium" data-id="element-235">
                    <div className="w-2 h-2 bg-espresso" data-id="element-236" />
                    {item}
                  </li>)}
              </ul>
              <Link to="/get-quote" className="w-full bg-charcoal text-alabaster py-5 font-bold uppercase tracking-widest hover:bg-espresso transition-colors text-center block" data-id="element-237">
                Claim Your 50% Savings
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>;
}